import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { LayoutProvider } from "../../layout/core";
import { UpgradeModalProvider } from "../../context/UpgradeModalContext";
import "react-toastify/dist/ReactToastify.css";
import LoadingSpinner from "../LoadingSpinner";
import "./Fixes.css";

const App: React.FC = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <UpgradeModalProvider>
        <LayoutProvider>
          <Outlet />
        </LayoutProvider>
      </UpgradeModalProvider>
    </Suspense>
  );
};

export default App;
